export var Align;
(function (Align) {
    Align["START"] = "start";
    Align["CENTER"] = "center";
    Align["END"] = "end";
})(Align || (Align = {}));
export var Position;
(function (Position) {
    Position["LEFT"] = "left";
    Position["TOP"] = "top";
    Position["RIGHT"] = "right";
    Position["BOTTOM"] = "bottom";
})(Position || (Position = {}));
